var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavAsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4409 16.9904L23.6119 27.2444C23.8504 27.4835 24.1338 27.6731 24.4458 27.8026C24.7578 27.932 25.0922 27.9987 25.4299 27.9987C25.7677 27.9987 26.1021 27.932 26.4141 27.8026C26.726 27.6731 27.0094 27.4835 27.2479 27.2444V27.2444C27.7278 26.763 27.9972 26.111 27.9972 25.4313C27.9972 24.7517 27.7278 24.0997 27.2479 23.6183L17.1239 13.4113",
    stroke: "#00263E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5579 4.00134C10.1948 4.00486 9.83254 4.03831 9.4749 4.10135L13.8749 8.50134L8.77489 13.6013L4.19194 9.01935C3.87088 10.3441 3.97072 11.7359 4.47764 13.0012C4.98457 14.2665 5.87335 15.3422 7.02025 16.0788C8.16714 16.8154 9.51514 17.1762 10.8766 17.1108C12.2381 17.0455 13.5454 16.5574 14.6165 15.7144C15.6876 14.8714 16.4693 13.7155 16.8528 12.4075C17.2362 11.0995 17.2024 9.70445 16.756 8.41656C16.3096 7.12868 15.4728 6.01198 14.362 5.22189C13.2513 4.4318 11.922 4.00762 10.5589 4.00836L10.5579 4.00134Z",
    stroke: "#00263E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavAsActive);
export default __webpack_public_path__ + "static/media/navAsActive.20f684bdbd5dffd35b60aa584446defe.svg";
export { ForwardRef as ReactComponent };